import { render, staticRenderFns } from "./InspectionStatusBadge.vue?vue&type=template&id=3ddce72a"
import script from "./InspectionStatusBadge.vue?vue&type=script&lang=js"
export * from "./InspectionStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports